import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-politica-privacidade',
  templateUrl: './politica-privacidade.component.html',
  styleUrls: ['./politica-privacidade.component.scss']
})
export class PoliticaPrivacidadeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
